export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 18.5V34.793L1.20703 18.5H17.5ZM35.5 0.5V34.793L18.5 17.793V17.5H18.207L1.20703 0.5H35.5Z" fill="transparent" stroke="${stroke}"/>
</svg>
`;
